import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledActivityContainer = styled.div`
	display: flex;
	justify-content: center;
	// align-items: flex-start;
	position: relative;
	width: 100%;
	// height: auto;
	margin-top: 0px;
`;

export const StyledError = styled.p`
	width: 100%;
	color: ${({ theme }) => theme.colors.error};
`;
